import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { GeneralContext } from "../../contexts/GeneralContext";

// Última ruta del Switch: una URL de /app que no matchea ninguna pantalla (por ejemplo
// el link genérico /app/checkin/, sin reserva) dejaba la pantalla en blanco. Va al menú,
// y sin sesión PrivateRoute la manda al login (NX#164429).
const UnknownRoute = props => {
  const { LngLink } = useContext(GeneralContext);

  return (
    <Route
      {...props}
      render={() => (
        <Redirect to={`${LngLink}${process.env.REACT_APP_ROOT_PATH_LINK}/`} />
      )}
    />
  );
};

export default UnknownRoute;
